import { ShipstationIntegrationApiClient } from '@fourthwall/services/dist/ShipstationIntegrationApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useFetchShipStationStoresQuery = createQueryHook(
  ShipstationIntegrationApiClient.getShipstationStoresFromKey,
  {
    queryKey: ['fetchShipStationStores'],
  },
)
